export const search = window.location.search;
